import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
// import * as CrudServices from "../../../../../service/crudServices";
import { Checkbox, Input } from "antd";
import { IconSearch } from "../../../asset";
import { setGlobalDA, setGlobalIsGetDetail } from "../../../store/reducer/globalMultipleSearchSelect.reducer";
import { GROLOG_ORDER_URL, GROLOG_URL } from "../../../constant/apiConstant";
import axios from "axios";

const MSSDeliveryAssociate = ({
  setValueMSS,
  valueMSS,
  children,
  togglerClassName,
  placeholder,
  className,
  filterByGrologAccountId,
  ...attrs
}) => {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [listData, setListData] = useState([]);
  const [listSelected, setListSelected] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalData, setTotalData] = useState(null);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const {
    globalOrderFrom,
    globalDepotName,
    globalDAStatus,
    globalDA,
    globalOrderStatus,
    globalTrip,
    globalTripStatus,globalIsGetDetail
  } = useSelector((state) => state.globalMSS);

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const getTotalData = useCallback(async () => {
    let datas ={
      "page" : 1,
      "limit" : 10,
      "order" : "",
      "connector" : "",
      "other" : {
        "depot_id_list": {
            "list_id": globalDepotName?.every(item => item >= 0)&& typeof globalDepotName[0] === 'object' ? globalDepotName?.map((el)=>el?.id) : globalDepotName,
            "exclude": false
        },
        "delivery_associate_status": {
            "list": globalDAStatus,
            "exclude": false
        },
        "driver_type": {
            "list": [
                "Owned",
                "Outsource"
            ],
            "exclude": false
        },
        "vehicle_ownership_filter": {
            "list": [
                "Owned",
                "Outsource"
            ],
            "exclude": false
        }
    }
  }
    let res = await doPost(`/delivery-associate/dropdown-report/initiate`, token, datas);
    if (res?.data?.payload?.data !== null) {
      setTotalData(res?.data?.payload?.data?.count_data);
      return;
    }
    setTotalData(null);
  }, [token, globalDepotName, globalDAStatus]);

  useEffect(() => {
    getTotalData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(()=>{
  //   setListSelected(globalDA)
  // },[globalDA])
  
  useEffect(()=>{
    if(globalIsGetDetail){
    setListSelected(
      // globalDepotName.every(item => item >= 0) ? 
      // globalDepotName.map((item)=> {
      // return { id: item }}) : globalDepotName)
      globalDA?.every(item => item >= 0)&& typeof globalDA[0] !== 'object' ? 
      listData?.filter(itemB => globalDA?.includes(itemB?.id)): globalDA)
    
      dispatch(setGlobalIsGetDetail(false))
    }
    // dispatch(setGlobalIsGetDetail(true))
  },[globalDA])

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const api = GROLOG_URL;
    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };
  const getListDeliveryAssociate = useCallback(
    async (newParams) => {
      let datas ={
        ...newParams,
        "order" : "",
        "connector" : "",
        "other" : {
          "depot_id_list": {
              "list_id": globalDepotName?.length >0&& typeof globalDepotName[0] === 'object' ? globalDepotName?.map((el)=>el?.id) : globalDepotName,
              "exclude": false
          },
          "delivery_associate_status": {
              "list": globalDAStatus?.length >0&& typeof globalDAStatus[0] === 'object' ? globalDAStatus?.map((el)=>el?.id) : globalDAStatus,
              "exclude": false
          },
          "driver_type": {
              "list": [
                  "Owned",
                  "Outsource"
              ],
              "exclude": false
          },
          "vehicle_ownership_filter": {
              "list": [
                  "Owned",
                  "Outsource"
              ],
              "exclude": false
          }
      }
    }
      let res = await doPost(`/delivery-associate/dropdown-report`, token, datas);

      if (res?.data?.payload?.data !== null) {
        const list = res?.data?.payload?.data.map((el) => {
          return {
            id: el?.delivery_associate_id,
            full_name: el?.first_name,
          };
        });

        if (newParams?.filter && newParams?.filter.includes("full_name")) {
          setListData([...list]);
          return;
        }
        list.unshift({ id: -1, full_name: "Select All" });
        setListData([...list]);
      }
      if (res?.ok && res?.data === null) {
        setListData([{ id: -1, full_name: "Select All" }]);
      }
    },
    [token, globalDepotName, globalDAStatus]
  );

  const handleClickSelectData = useCallback(
    (item) => {
      if (item?.id === -1) {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected([-1]);
          dispatch(setGlobalDA([-1]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes(-1)) {
            setListSelected([]);
            dispatch(setGlobalDA([]));
            return;
          }
          setListSelected([-1]);
          dispatch(setGlobalDA([-1]));
          return;
        }
        if (listSelected.length && listSelected.includes(-1)) {
          setListSelected([]);
          dispatch(setGlobalDA([]));
        }

        return;
      }
      if (item?.id !== -1) {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setGlobalDA([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes(-1);

        if (isAllSelected) {
          const idFiltering = [-1];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setGlobalDA([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setGlobalDA([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setGlobalDA([...list]));
          return;
        }
      }
    },
    [dispatch, listData, listSelected, totalData]
  );

  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes(-1)) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item?.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllTrip = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes(-1)) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);

  const onChangeSearch = useCallback((val) => {
    setSearchKeyword(val);
  }, []);

  useEffect(() => {
    if (!searchKeyword && globalDepotName && globalDAStatus) {
      const resetParams = {
        page: 1,
        limit: 100,
      };
      getListDeliveryAssociate(resetParams);
      return;
    }
    if(searchKeyword&& globalDepotName && globalDAStatus){
    const newParams = {
      page: 1,
      limit: 100,
      filter: `full_name lk ${searchKeyword}`,
    };
    getListDeliveryAssociate(newParams);
  }
  }, [filterByGrologAccountId, getListDeliveryAssociate, searchKeyword,globalDepotName, globalDAStatus]);

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className={`value-mss `}
        onClick={togglerDropdownContent}
        ref={btnDropdownRef}
        disabled={!globalDepotName || !globalDAStatus}
      >
        {isAllTrip ? (
          <span className="list-value-mss">All DeliveryAssociate</span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.full_name}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select DeliveryAssociate</span>
        )}
      </button>
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="my-2 px-2">
          <Input
            placeholder="Search By DeliveryAssociate Name"
            size="large"
            suffix={<img src={IconSearch} alt="icon-search" />}
            onChange={(evt) => onChangeSearch(evt.target.value)}
          />
        </div>
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.full_name}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MSSDeliveryAssociate;
